var map = {
	"./100-mil-book-aus.svg": 200,
	"./100-mil-book-es.svg": 201,
	"./100-mil-book.svg": 202,
	"./3000-outlets-aus.svg": 203,
	"./3000-outlets-es.svg": 204,
	"./3000-outlets.svg": 205,
	"./50-countries-aus.svg": 206,
	"./50-countries-es.svg": 207,
	"./50-countries.svg": 208,
	"./70-mil-authors-aus.svg": 209,
	"./70-mil-authors-es.svg": 210,
	"./70-mil-authors.svg": 211,
	"./Componente 6 – 2.svg": 212,
	"./Componente 7 – 2.svg": 213,
	"./Componente 8 – 2.svg": 214,
	"./Google_Play.svg": 215,
	"./Logo_ESP_BRANCO.png": 216,
	"./Logo_ESP_ROXO.png": 217,
	"./a4-white.svg": 218,
	"./a4.svg": 219,
	"./a5-white.svg": 220,
	"./a5.svg": 221,
	"./after-01.png": 222,
	"./after-02.png": 223,
	"./after-03.png": 224,
	"./agbook-logo-editor-load.jpg": 225,
	"./agbook-logo-mobile-2.jpg": 226,
	"./agbook-logo-mobile.png": 132,
	"./agbook-logo.png": 227,
	"./alphagraphics.svg": 228,
	"./amex.svg": 229,
	"./authorfreely_primarylogo.png": 120,
	"./background-service-all.png": 230,
	"./background-stores.jpg": 231,
	"./banner_partner_stores.png": 232,
	"./bb.svg": 233,
	"./blogger-round-svgrepo-com.svg": 234,
	"./boleto.svg": 235,
	"./book-1.png": 236,
	"./book-2.png": 237,
	"./book-3.png": 238,
	"./book-old.png": 239,
	"./book-type-orange.svg": 240,
	"./book-type-red.svg": 241,
	"./book-type.png": 242,
	"./book-type.svg": 243,
	"./book-upload-icon.svg": 244,
	"./book.png": 245,
	"./bottom-background.png": 246,
	"./bradesco.svg": 247,
	"./brand-tiktok-svgrepo-com.svg": 248,
	"./card-icon-1.svg": 249,
	"./card-icon-2.svg": 250,
	"./card-icon-3.svg": 251,
	"./card-icon-4.svg": 252,
	"./card.svg": 253,
	"./chevron-right-black.svg": 254,
	"./chevron-right.svg": 255,
	"./close.svg": 256,
	"./completed-purchase-book-aus.png": 257,
	"./completed-purchase-book.png": 258,
	"./congratulations-aus.png": 259,
	"./cover-revision.png": 260,
	"./creditcard.png": 261,
	"./cta-desktop-en.png": 262,
	"./cta-desktop-red.png": 263,
	"./cta-desktop.png": 264,
	"./cta-desktop_es.jpg": 265,
	"./cta-mobile-en.png": 266,
	"./cta-mobile-red.png": 267,
	"./cta-mobile.png": 268,
	"./cta-mobile_es.jpg": 269,
	"./diners.svg": 270,
	"./esboco.png": 271,
	"./esboco.svg": 272,
	"./facebook-share-pink.svg": 273,
	"./facebook.svg": 274,
	"./first-circle.svg": 275,
	"./frete-gratis.png": 276,
	"./hero-background-mobile.png": 277,
	"./hero-background.png": 278,
	"./hero-book-image.png": 279,
	"./hipercard.svg": 280,
	"./icon-a4.svg": 281,
	"./icon-a5.svg": 282,
	"./icon-add.svg": 283,
	"./icon-amazon.svg": 284,
	"./icon-americanas.svg": 285,
	"./icon-apple.svg": 286,
	"./icon-arrow-down-grey.svg": 287,
	"./icon-arrow-down-purple-orange.svg": 288,
	"./icon-arrow-down-purple-white.svg": 289,
	"./icon-arrow-down-purple.svg": 290,
	"./icon-arrow-left-pagination.svg": 291,
	"./icon-arrow-right-orange.svg": 292,
	"./icon-arrow-right-pagination.svg": 293,
	"./icon-arrow-right-pink.svg": 294,
	"./icon-arrow-right-white.svg": 295,
	"./icon-book-grey.svg": 296,
	"./icon-book-orange.svg": 297,
	"./icon-book-purple.svg": 298,
	"./icon-book-white.svg": 299,
	"./icon-burger-purple.svg": 300,
	"./icon-burger-white.svg": 301,
	"./icon-camera.svg": 302,
	"./icon-cart-grey.svg": 303,
	"./icon-cart-white.svg": 304,
	"./icon-chat-orange.svg": 305,
	"./icon-chat-red.svg": 306,
	"./icon-chat.svg": 307,
	"./icon-check-green.svg": 308,
	"./icon-check-pink.svg": 309,
	"./icon-check-red.svg": 310,
	"./icon-check-white.svg": 311,
	"./icon-chevron_left-orange.svg": 312,
	"./icon-chevron_left-red.svg": 313,
	"./icon-chevron_left.svg": 314,
	"./icon-chevron_right.svg": 315,
	"./icon-close-quote.svg": 316,
	"./icon-cross-purple.svg": 317,
	"./icon-cross-red.svg": 318,
	"./icon-cross-white.svg": 319,
	"./icon-donthave.svg": 320,
	"./icon-download.svg": 321,
	"./icon-ebook-orange.svg": 322,
	"./icon-ebook.svg": 323,
	"./icon-epub.svg": 324,
	"./icon-estantevirtual.svg": 325,
	"./icon-exit-aila-editor.svg": 326,
	"./icon-export.svg": 327,
	"./icon-external.svg": 328,
	"./icon-facebook-purple.svg": 329,
	"./icon-feature-detail.svg": 330,
	"./icon-full-cover.svg": 331,
	"./icon-globe.png": 332,
	"./icon-googleplay.svg": 333,
	"./icon-has.svg": 334,
	"./icon-hasnt.svg": 335,
	"./icon-have.svg": 336,
	"./icon-header-aila-editor.svg": 337,
	"./icon-image-gallery.svg": 338,
	"./icon-image-upload.svg": 339,
	"./icon-livrariacultura.svg": 340,
	"./icon-logo-blog-white.svg": 341,
	"./icon-lp-1-orange.svg": 342,
	"./icon-lp-1-red.svg": 343,
	"./icon-lp-1.svg": 344,
	"./icon-lp-2-orange.svg": 345,
	"./icon-lp-2-red.svg": 346,
	"./icon-lp-2.svg": 347,
	"./icon-lp-3-red.svg": 348,
	"./icon-lp-3.svg": 349,
	"./icon-mercadolivre.svg": 350,
	"./icon-mini-book-orange.svg": 351,
	"./icon-mini-book.svg": 352,
	"./icon-money-orange.svg": 353,
	"./icon-money-purple.svg": 354,
	"./icon-open-chart-orange.svg": 355,
	"./icon-open-chart.svg": 356,
	"./icon-open-quote.svg": 357,
	"./icon-person-grey.svg": 358,
	"./icon-person-white.svg": 359,
	"./icon-play-two.svg": 360,
	"./icon-play.svg": 361,
	"./icon-pocket.svg": 362,
	"./icon-print-orange.svg": 363,
	"./icon-print.svg": 364,
	"./icon-profile-orange.svg": 365,
	"./icon-profile-red.svg": 366,
	"./icon-profile.svg": 367,
	"./icon-quadrado.svg": 368,
	"./icon-questionmark-orange.svg": 369,
	"./icon-questionmark-red.svg": 370,
	"./icon-questionmark.svg": 371,
	"./icon-rakuten.svg": 372,
	"./icon-search-purple-orange.svg": 373,
	"./icon-search-purple.svg": 374,
	"./icon-select-arrow.svg": 375,
	"./icon-separated-cover.svg": 376,
	"./icon-seu-livro-red.png": 377,
	"./icon-seu-livro.png": 378,
	"./icon-speak-orange.svg": 379,
	"./icon-speak-purple.svg": 380,
	"./icon-submarino.svg": 381,
	"./icon-trash-can.svg": 382,
	"./icon-trash.svg": 383,
	"./icon-tu-libro.png": 384,
	"./icon-twitter-purple.svg": 385,
	"./icon-upload-white.svg": 386,
	"./icon-upload.svg": 387,
	"./icon_linkedin.svg": 388,
	"./icons8-check.gif": 389,
	"./img-footer-es.svg": 390,
	"./img-footer.svg": 391,
	"./img2-footer-aus.svg": 392,
	"./img2-footer-es.svg": 393,
	"./img2-footer.svg": 394,
	"./info-orange.svg": 395,
	"./info-pink.svg": 396,
	"./info-red.svg": 397,
	"./info.svg": 398,
	"./info1.jpg": 399,
	"./info2.jpg": 400,
	"./info3.jpg": 401,
	"./instagram-share-pink.svg": 402,
	"./instagram.svg": 403,
	"./itau.svg": 404,
	"./linkedin.svg": 405,
	"./lock.svg": 406,
	"./logo-amazon-color.png": 407,
	"./logo-amazon.png": 408,
	"./logo-americanas-color.png": 409,
	"./logo-americanas.png": 410,
	"./logo-apple-color.png": 411,
	"./logo-apple.png": 412,
	"./logo-authorfreely-mobile.png": 121,
	"./logo-cda-mobile.svg": 413,
	"./logo-cda.svg": 414,
	"./logo-club-de-autores.png": 415,
	"./logo-clube-de-autores-share.png": 416,
	"./logo-clube-de-autores-share.svg": 417,
	"./logo-clube-de-autores.svg": 418,
	"./logo-cultura-color.png": 419,
	"./logo-cultura.png": 420,
	"./logo-estante-color.png": 421,
	"./logo-estante.png": 422,
	"./logo-google-color.png": 423,
	"./logo-google.png": 424,
	"./logo-mercado-color.png": 425,
	"./logo-mercado.png": 426,
	"./logo-rakuten-color.png": 427,
	"./logo-rakuten.png": 428,
	"./logo-submarino-color.png": 429,
	"./logo-submarino.png": 430,
	"./lp-banner-a-desktop.png": 431,
	"./lp-banner-a-mobile.png": 432,
	"./lp-banner-b-desktop-red.png": 433,
	"./lp-banner-b-desktop.png": 434,
	"./lp-banner-b-mobile-red.png": 435,
	"./lp-banner-b-mobile.png": 436,
	"./mastercard.svg": 437,
	"./new-icon-facebook.svg": 438,
	"./new-icon-linkedin.svg": 439,
	"./new-icon-twitter.svg": 440,
	"./norton.svg": 441,
	"./pix.png": 442,
	"./pocket-white.svg": 443,
	"./pocket.svg": 444,
	"./publish-book.png": 445,
	"./publish-book_agbook-2.png": 446,
	"./publish-book_agbook.png": 447,
	"./publish-book_en.png": 448,
	"./publish-book_es.png": 449,
	"./quadrado-white.svg": 450,
	"./quadrado.svg": 451,
	"./room-circle.svg": 452,
	"./second-circle.svg": 453,
	"./slider-arrow-left-grey.svg": 454,
	"./slider-arrow-right-grey.svg": 455,
	"./stars_1-orange.svg": 456,
	"./stars_1-red.svg": 457,
	"./stars_1.svg": 458,
	"./stars_2-orange.svg": 459,
	"./stars_2-red.svg": 460,
	"./stars_2.svg": 461,
	"./stars_3-orange.svg": 462,
	"./stars_3-red.svg": 463,
	"./stars_3.svg": 464,
	"./stars_4-orange.svg": 465,
	"./stars_4-red.svg": 466,
	"./stars_4.svg": 467,
	"./stars_5-orange.svg": 468,
	"./stars_5-red.svg": 469,
	"./stars_5.svg": 470,
	"./stars_sprint.png": 471,
	"./stars_sprint.svg": 472,
	"./stars_sprint_orange.svg": 473,
	"./stars_sprint_red.svg": 474,
	"./third-circle.svg": 475,
	"./twitter-share-pink.svg": 476,
	"./twitter.svg": 477,
	"./user-account-en.png": 478,
	"./user-book.png": 479,
	"./visa.svg": 480,
	"./whatsapp.svg": 481,
	"./word-file-icon.svg": 482,
	"./word-message-aus.svg": 483,
	"./word-message-es.svg": 484,
	"./word-message.svg": 485,
	"./wordpress.svg": 486,
	"./your-book-mini-aus.png": 487,
	"./youtube-play-svgrepo-com.svg": 488
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 199;